import React, { FC, useCallback, useMemo } from 'react'
import { Badge } from '@wmgtech/legato'

import { Tag } from 'shared/__gql-types'
import { FilterTagsProps } from './FilterTags.props'

import styles from './FilterTags.module.scss'

export const FilterTags: FC<FilterTagsProps> = ({ values, onSelect, tagsList }) => {
  const selectedTags = useMemo(() => values.reduce((acc: Record<string, Tag>, tag) => ({
    ...acc,
    [tag.label]: tag,
  }), {}), [values])

  const toggleTag = useCallback((tag: Tag) => () => selectedTags?.[tag.label] ?
    onSelect(values.filter((t) => tag.label !== t.label)) :
    onSelect([...values, tag]),[selectedTags, onSelect, values])

  return (
    <div className={styles.container}>
      {tagsList.map(({ label, id, order_number }) => {
        return (
          <div onClick={toggleTag({ label, id, order_number })} key={id} className={styles.badge}>
            <Badge
              className={selectedTags?.[label] ? styles.badgeItemChecked : styles.badgeItem}
              text={label}
              containerStyle={selectedTags?.[label] ? 'solid' : 'outline'}
              colorType="dark"
              size="sm"
            />
          </div>
        )
      })}
    </div>
  )
}
